import { UseMutationOptions, useMutation } from '@tanstack/react-query';

import { z } from 'zod';

import {
  PostImageAnalysisError,
  PostImageAnalysisVariables,
  fetchPostImageAnalysis,
} from '../toolkitComponents.ts';
import { useToolkitContext } from '../toolkitContext.ts';
import { Registry } from './registry.ts';

type Response = z.infer<typeof schResponse>;
const {
  schemas: { REQUEST: schRequest, RESPONSE: schResponse },
} = Registry.postImageAnalysis;

/** @deprecated - Delete once ImageAnalysisDemoRouteElement is replaced */
export const usePostImageAnalysis = (
  options?: Omit<
    UseMutationOptions<Response, PostImageAnalysisError, PostImageAnalysisVariables>,
    'mutationFn'
  >,
) => {
  const { fetcherOptions } = useToolkitContext();

  return useMutation<Response, PostImageAnalysisError, PostImageAnalysisVariables>(
    (variables: PostImageAnalysisVariables) =>
      fetchPostImageAnalysis({
        ...fetcherOptions,
        ...variables,
        body: schRequest.BODY.parse(variables.body),
      }).then((r) => schResponse.parse(r)),
    options,
  );
};
